import en from './locales/en.json'
import he from './locales/he.json'
import ar from './locales/ar.json'

const messages = {
  he,
  en: { ...he, ...en },
  ar: {...he, ...en, ...ar}
}

export default messages
